import React, { Component } from 'react';
import moment from 'moment';
import { Slider } from 'antd';
import { Icon } from 'antd';
import {
  Wrapper,
  MinMaxWrap,
  Min,
  Max,
  SliderComponent,
  CloseText,
  Triangle,
  TriangleWrapper,
  ResetLink,
  FilterTitle
} from './styles';
import MultiSelect from '../../Components/MultiSelect/MultiSelect';
import PropTypes from 'prop-types';

function ModalMobile(filters, selected, mobileViewHandler, reset) {
  let min = Number(moment(filters[1].minRange).format('YYYY'));
  let max = Number(moment(filters[1].maxRange).format('YYYY'));
  let options = [];
  options.push({
    key: 'select',
    value: '--select--'
  });
  filters[2].choices.forEach((opt) => {
    options.push({
      key: opt,
      value: opt
    });
  });
  let roleOptions = [];
  roleOptions.push({
    key: 'select',
    value: '--select--'
  });
  filters[3].choices.forEach((opt)=>{
    roleOptions.push({
      key: opt,
      value: opt
    });
  });
  return (
    <Wrapper>
      <TriangleWrapper>
        <Triangle />
      </TriangleWrapper>
      <Wrapper Background>
        <Wrapper PaddingTop>
          <ResetLink data-test = "filters-0" onClick={() => reset(filters[0])} floated>
            Reset
          </ResetLink>
          <FilterTitle>Balance</FilterTitle>
          <SliderComponent disabled={filters[0].minRange === -1 ? true : false}>
            <Slider
              range
              disabled={filters[0].minRange === -1 ? true : false}
              min={Math.floor(filters[0].minRange)}
              max={Math.ceil(filters[0].maxRange)}
              step={1}
              defaultValue={[
                filters[0].selectedMin
                  ? filters[0].selectedMin
                  : filters[0].minRange,
                filters[0].selectedMax
                  ? filters[0].selectedMax
                  : filters[0].maxRange
              ]}
              onAfterChange={value => selected(value, 'balance')}
              key={'test'}
            />
          </SliderComponent>
          <MinMaxWrap>
            <Min>Min</Min>
            <Max>Max</Max>
          </MinMaxWrap>
        </Wrapper>
        <Wrapper PaddingTop>
          <ResetLink data-test = "filters-1" onClick={() => reset(filters[1])} floated>
            Reset
          </ResetLink>
          <FilterTitle>Year Opened</FilterTitle>
          <SliderComponent>
            <Slider
              range
              min={min}
              max={max}
              step={1}
              defaultValue={[
                filters[1].selectedMin
                  ? filters[1].selectedMin
                  : min,
                filters[1].selectedMax
                  ? filters[1].selectedMax
                  : max
              ]}
              onAfterChange={value => selected(value, 'year')}
              key={'test'}
            />
          </SliderComponent>
          <MinMaxWrap>
            <Min>Min</Min>
            <Max>Max</Max>
          </MinMaxWrap>
        </Wrapper>
        <Wrapper PaddingTop>
          <ResetLink data-test = "filters-2" onClick={() => reset(filters[2])} floated>
            Reset
          </ResetLink>
          <FilterTitle>States</FilterTitle>
          <MultiSelect
            filterModal={true}
            filterSelect={true}
            options={options}
            defaultValue={'select'}
            mode='multiple'
            showArrow={true}
            sorted={value => selected(value, 'states')}
            value={filters[2].selectedVal}
          />
        </Wrapper>
        <Wrapper PaddingTop>
          <ResetLink data-test = "filters-3" onClick={() => reset(filters[3])} floated>
            Reset
          </ResetLink>
          <FilterTitle>Designated Role</FilterTitle>
          <MultiSelect
            filterModal={true}
            filterSelect={true}
            options={roleOptions}
            defaultValue={'select'}
            value={filters[3].selectedVal}
            sorted={value => selected(value, 'roles')}
          />
        </Wrapper>
        <Wrapper CloseBtn>
          <CloseText key='closeText' data-test = "close-text" onClick={() => mobileViewHandler()}>
            Close <Icon type='close' />
          </CloseText>
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
}

class FilterModalMobile extends Component {
  render() {
    const { selected, mobileViewHandler, reset } = this.props;
    let generteModal = ModalMobile(
      this.props.filters,
      selected,
      mobileViewHandler,
      reset
    );
    return <>{generteModal}</>;
  }
}
FilterModalMobile.propTypes = {
  closed:PropTypes.func,
  filters:PropTypes.arrayOf(PropTypes.object),
  reset:PropTypes.func,
  selected:PropTypes.func,
  mobileViewHandler:PropTypes.func
}
export default FilterModalMobile;
